import React,{ FC, useEffect, useRef, useState } from "react";
import styles from "./index.module.less";
import { RightOutline} from 'antd-mobile-icons'
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import { InvoiceType } from "~src/service/bill/bill";
import { getInvoiceList } from "~src/service/bill";
import { Empty, InfiniteScroll } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import useQuery from "~src/hooks/useQuery";
import classNames from "classnames";
import { green_living_empty } from "~src/constants/network";


interface  HistoryCardProps {
  item: InvoiceType
  biz: string
}

const HistoryCard:FC<HistoryCardProps> = ({item,biz}) =>{
  const navigate = useNavigate()
  return <div className={styles.card} onClick={() => {
    navigate(`/bill/details?id=${item.outInvoiceId}&biz=${biz}`)
  }}>
    <div className={styles["card-header"]}>
      <div className={styles["card-header-left"]}>
        <div className={styles["card-header-left-label"]}>申请时间：</div>
        <div className={styles["card-header-left-value"]}>{item.createdAt}</div>
      </div>
      <div className={classNames(styles["card-header-right"], item.status !== 0 && styles["card-header-start"])}>
        <span>{item.status === 0 ? "未开票": "已开票"}</span>
        <RightOutline />
      </div>
    </div>
    <div className={styles["card-content"]}>
      <div className={styles["card-content-left"]}>
        <div className={styles["card-content-left-name"]}>{item.title}</div>
        <div className={styles["card-content-left-tag"]}>电子发票</div>
      </div>
      <div className={styles["card-content-amount"]}>¥{item.totalAmount}</div> </div>
  </div>
}



const BillHistory: FC = () => {
  useDocumentTitle('开票历史')
  const searchQuery = useQuery()
  const biz = searchQuery("biz")
  const [list, setList] = useState<InvoiceType[]>([])
  const [hasMore, setHasMore] = useState<boolean>(false)
  const conf = useRef({
    page: 0,
    pageSize: 10,
    bizName: biz
  })
  const loadMore = async() =>{
    conf.current.page += 1
    conf.current.bizName = biz
    const {list, hasNext} = await getInvoiceList(conf.current)
    setList(val => [...val, ...list])
    setHasMore(hasNext)
  }
  const doSearch = () => {
    setList([])
    setHasMore(true)
    loadMore()
  }
  useEffect(() => {
    doSearch()
  }, [])
  return <div className={styles.history}>
    <div className={styles["history-tips"]}>仅显示近12个月的开票历史</div>
    {list.length > 0 ? (
        <>
            {list.map((item, index) => (
                <div key={item.outInvoiceId} className={styles["history-item"]}><HistoryCard item={item} biz={biz}/></div>
            ))}
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </>
      ) :  <Empty imageStyle={{width: "240px"}} image={green_living_empty} />
    }
  </div>
}
export default BillHistory